import api from './api'

export const DefaultApi = api(`${process.env.REACT_APP_PROFILE_BFF}`, {})

export const WebsiteApi = api(`${process.env.REACT_APP_FRETEBRAS_SITE}/api`, {})
